var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1663 2.41665C19.1663 2.33331 19.1663 2.24998 19.083 2.16665V2.08331C19.083 1.99998 18.9997 1.91665 18.9163 1.83331C18.8747 1.79165 18.833 1.77081 18.7913 1.74998C18.7497 1.72915 18.708 1.70831 18.6663 1.66665H18.583C18.4997 1.66665 18.4163 1.66665 18.333 1.58331V1.66665C18.2497 1.66665 18.1663 1.66665 18.083 1.74998L1.41634 7.58331C1.08301 7.66665 0.833008 7.91665 0.833008 8.33331C0.833008 8.66665 0.999674 8.99998 1.33301 9.16665L8.49967 12.3333L11.6663 19.5C11.833 19.8333 12.083 20 12.4163 20C12.7497 20 13.083 19.75 13.1663 19.4166L18.9997 2.74998C19.1663 2.66665 19.1663 2.58331 19.1663 2.41665ZM8.99964 10.6666L3.91631 8.41665L15.1663 4.49998L8.99964 10.6666ZM10.1663 11.8333L12.4163 16.9166L16.333 5.66665L10.1663 11.8333Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_5319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1663 2.41665C19.1663 2.33331 19.1663 2.24998 19.083 2.16665V2.08331C19.083 1.99998 18.9997 1.91665 18.9163 1.83331C18.8747 1.79165 18.833 1.77081 18.7913 1.74998C18.7497 1.72915 18.708 1.70831 18.6663 1.66665H18.583C18.4997 1.66665 18.4163 1.66665 18.333 1.58331V1.66665C18.2497 1.66665 18.1663 1.66665 18.083 1.74998L1.41634 7.58331C1.08301 7.66665 0.833008 7.91665 0.833008 8.33331C0.833008 8.66665 0.999674 8.99998 1.33301 9.16665L8.49967 12.3333L11.6663 19.5C11.833 19.8333 12.083 20 12.4163 20C12.7497 20 13.083 19.75 13.1663 19.4166L18.9997 2.74998C19.1663 2.66665 19.1663 2.58331 19.1663 2.41665ZM8.99964 10.6666L3.91631 8.41665L15.1663 4.49998L8.99964 10.6666ZM10.1663 11.8333L12.4163 16.9166L16.333 5.66665L10.1663 11.8333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_5319)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ded8eb07e7ef5afc4a8654c1f39a6bcc.svg";
export { ForwardRef as ReactComponent };